import { capitalize } from 'lodash';
import { Card, CardContent } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles({ name: 'ElevatedCard' })((theme) => ({
  radiusSmall: {
    borderRadius: theme.radii.small,
  },
  radiusMedium: {
    borderRadius: theme.radii.medium,
  },
  radiusLarge: {
    borderRadius: theme.radii.large,
  },
}));

interface ElevatedCardProps {
  readonly children: React.ReactNode;
  readonly radius?: 'small' | 'medium' | 'large';
  readonly className?: string;
}

export const ElevatedCard: React.FC<ElevatedCardProps> = ({
  children, radius = 'large', className = '',
}) => {
  const { classes, cx } = useStyles();

  return (
    <Card
      elevation={4}
      className={cx(className, classes[`radius${capitalize(radius)}`])}
    >
      <CardContent>
        {children}
      </CardContent>
    </Card>
  );
};
